import script from "./DoctorInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./DoctorInfo.vue?vue&type=script&setup=true&lang=js"

import "./DoctorInfo.vue?vue&type=style&index=0&id=ec08f9a4&scoped=true&lang=scss"

import exportComponent from "/builds/gu1sQVEd/1/fe-huihui/fed-doctor-helper-ms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec08f9a4"]])

export default __exports__